import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Provider } from 'app/models2/administration/provider';
import { User } from 'app/models2/administration/user';
import { Data, DataResouce } from 'app/models2/commos/base-response-data';
import { InputOrOutputInventory } from 'app/models2/inventory/input-or-output-inventory';
import { Resources } from 'app/models2/maintenance/resources';
import { WorkOrder } from 'app/models2/maintenance/work-order';
import { CommentService } from 'app/services/comment.service';
import { NotificationsService } from 'app/services/notifications.service';
import { UtilsServiceService } from 'app/services/utils-service.service';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { HttpService, LocalStorageService, MenuBreadCrumb, MessageService, SessionService} from 'brainloper-ui';

@Component({
  selector: 'app-storer-request',
  templateUrl: './storer-request.component.html',
  styleUrls: ['./storer-request.component.scss']
})
export class StorerRequestComponent implements OnInit {

  public bodyUsuarios: User[] | Provider[] = []

  public menuBreadCrumb:Array<MenuBreadCrumb> = [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
      name:"Notificaciones",
    },
    {
    name:"Solicitud Almacen",
    current:true
    }
  ]

  private urlTableResourcesWithWarehouse: string = `${EndpointDictionary.Resources.RESOURCES_WAREHOUSE_TABLE}`

  public movil: boolean
  public bodyOrden: WorkOrder = {}
  public view: boolean = false


  constructor(

    private message: MessageService,
    private storage : LocalStorageService,
    private session: SessionService,
    private router: Router,
    public notificationService: NotificationsService,
    public http: HttpService,
    private utils : UtilsServiceService,
    private commentService: CommentService,
  ) { }

  ngOnInit(): void {
    this.movil = screen.width > 600 ? false : true

  }

  async response($event: WorkOrder | User[] | Provider[] | Array<Resources>) {
    try {
      var resourcesRequest = await this.http.getDataBody<DataResouce<Array<InputOrOutputInventory>>>(this.urlTableResourcesWithWarehouse, [{ id: 'orderId', value: $event[0].id }])
      $event[2] = resourcesRequest.data
      $event[3] = resourcesRequest.warehouseIds.length > 1
      this.session.setData("packOffData", $event)
      let url = this.utils.getQueryParams(`almacen/salidas_inventario/detalle${ resourcesRequest.warehouseIds.length == 1?'?warehouseId='+ resourcesRequest.warehouseIds[0]:''}`);
      this.router.navigate([`${url.url}`], {
        queryParams: url.params,
      });
      this.message.SuccessToast('Notificacion Despachando Recursos')
    } catch (error) {
      this.message.Error('Error', error['message'])
    }
  }

  addComment(workOrder: WorkOrder) {
    this.commentService.addComment(workOrder.id);
  }

  }


